module.exports = __webpack_public_path__ + "static/media/icon_share_hash_tag.376655bc.webp";